import React from 'react'

import { AttackTypeIcon } from 'components/common/AttackTypeIcon'
import GlyphIcon from 'components/common/GlyphIcon'
import {
  AttackDescription,
  AttackRow,
  DetailsChevron
} from 'components/navigation/Notifications/AttackRows/common/AttackRow'
import { getNextScheduled } from 'components/navigation/Notifications/utils'
import useScenarioScheduleDetails from 'hooks/use-scenario-schedule-details'
import { ScheduledScenario } from 'types/schedules/scheduled-scenarios'

export const ScheduledScenarioRow: React.FC<{
  schedule: ScheduledScenario
}> = ({ schedule }) => {
  const { trigger, scenario_id } = schedule
  const { name, commandType } = useScenarioScheduleDetails(scenario_id)

  return (
    <AttackRow
      data-scheduled-scenario-row
      css={{
        gridTemplateColumns: '1fr 24px'
      }}
      to={`/scenarios/detail/${scenario_id}`}
    >
      <AttackDescription
        description={getNextScheduled(trigger)}
        icon={
          <GlyphIcon>
            <AttackTypeIcon icon={commandType} />
          </GlyphIcon>
        }
        name={name}
      />
      <DetailsChevron />
    </AttackRow>
  )
}
